import { I18n } from '@calendly/i18n';
import { Loader } from '@calendly/ui/components/loader';
import { Body, Row, Table } from '@calendly/ui/components/table';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useEffect, useRef, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { enableEndlessScroll, fetchInvitations, invitationsSelector, isLoadingSelector, paginationSelector, resetState, updatePage } from 'features/users_page';
import { TableContainer } from '../styles';
import { BatchControls } from './batch_controls';
import { PendingUser } from './pending_user';
const scrollingGapHeight = 10;
const loadingCellCss = "l1ftj8h6";
const LoadingCell = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'td';
  const colSpan = '3';
  return <Component ref={ref} {...restProps} colSpan={colSpan} className={classNames(loadingCellCss, props.className)} />;
});
export const PendingUsersList = () => {
  const dispatch = useDispatch();
  const {
    currentPage,
    totalPages,
    totalCount
  } = useSelector(paginationSelector);
  const invitations = useSelector(invitationsSelector);
  const isLoading = useSelector(isLoadingSelector);
  const scrollContainerRef = useRef(null);
  useEffect(() => {
    dispatch(enableEndlessScroll());
    dispatch(fetchInvitations());
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return undefined;
    const handleScroll = () => {
      const {
        scrollTop,
        clientHeight,
        scrollHeight
      } = scrollContainer;
      const shouldFetchMoreItems = scrollTop + clientHeight + scrollingGapHeight > scrollHeight;
      if (shouldFetchMoreItems && !isLoading && currentPage < totalPages) {
        dispatch(updatePage({
          page: currentPage + 1
        }));
        scrollContainer.scrollTop = scrollHeight;
      }
    };
    scrollContainer.addEventListener('scroll', handleScroll);
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [dispatch, isLoading, currentPage, totalPages]);
  if (!invitations.length) {
    if (isLoading) {
      return <Loader data-testid="loader" />;
    }
    return <BodyText>{I18n.t('publisher.admin.dashboard.section.users.modal.pending_users.empty')}</BodyText>;
  }
  return <>
      <BodyText>{I18n.t('publisher.admin.dashboard.section.users.modal.pending_users.description')}</BodyText>
      <BatchControls />
      <TableContainer ref={scrollContainerRef} data-testid="scrollable-table-container">
        <Table noContainerBorder>
          <Body>
            {invitations.map(invitation => <PendingUser key={invitation.id} invitation={invitation} />)}
            {isLoading && invitations.length !== totalCount && <Row><LoadingCell><Loader data-testid="loader" /></LoadingCell></Row>}
          </Body>
        </Table>
      </TableContainer>
    </>;
};

require("./pending_users_list.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./pending_users_list.js");